var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.filterInputType == "boolean"
      ? _c(
          "span",
          { staticClass: "input-boolean" },
          [
            _c("global-dropdown", {
              staticClass: "k-filter-v-input k-input k-picker-solid",
              attrs: {
                id: "custom-external-filter-boolean",
                options: _vm.booleanFilterOptions,
                size: 32,
                "full-width": true,
                placeholder: _vm.filterLabel
              },
              on: { change: _vm.handleBooleanChange },
              model: {
                value: _vm.inputValue,
                callback: function($$v) {
                  _vm.inputValue = $$v
                },
                expression: "inputValue"
              }
            })
          ],
          1
        )
      : _c(
          "span",
          [
            _c("v-text-field", {
              ref: "filterSearchInput",
              staticClass:
                "k-filter-v-input k-input k-picker-solid k-rounded-md",
              attrs: {
                label: _vm.filterLabel,
                value: _vm.inputValue,
                type: _vm.filterInputType,
                disabled: _vm.disabledInput,
                rules: !_vm.disabledInput ? _vm.requiredRules : [],
                "hide-details": "",
                dense: "",
                box: "",
                "background-color": "#fff"
              },
              on: { input: _vm.handleFilterInput }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }